import Vue from "vue";
import Vuex from "vuex";
import feedback from "./modules/feedback";
import createLogger from "vuex/dist/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    feedback
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/public_app/store/index.js